/**
 * Environment configuration for the application
 */

export const config = {
  // Environment mode
  env: process.env.REACT_APP_ENV || 'production',

  // API configuration
  apiBaseUrl: process.env.REACT_APP_BASE_DOMAIN || 'http://localhost:8000',

  // CORS configuration
  corsEnabled: process.env.REACT_APP_CORS_ENABLED === 'true',

  // Asset URLs
  assetUrl: process.env.REACT_APP_ASSET_URL || window.location.origin,

  // Feature flags
  isDevelopment: process.env.REACT_APP_ENV === 'development',
  isProduction: process.env.REACT_APP_ENV === 'production',
};

/**
 * Get the full API URL for a given endpoint
 */
export const getApiUrl = (endpoint: string): string => {
  // Remove /api prefix if present since we'll add it
  let cleanEndpoint = endpoint.replace(/^\/api/, '');
  // Ensure endpoint starts with /
  cleanEndpoint = cleanEndpoint.startsWith('/') ? cleanEndpoint : `/${cleanEndpoint}`;
  // Add /api prefix
  return `${config.apiBaseUrl}/api${cleanEndpoint}`;
};

/**
 * Get the full asset URL for a given path
 */
export const getAssetUrl = (path: string): string => {
  // If it's already a full URL, return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // For local Audio files (stored in /Audio directory), use the frontend asset URL
  // These files are served by the React development server from the public folder
  // In production, these will be at the root of the domain
  if (path.startsWith('/Audio/')) {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `${config.assetUrl}${cleanPath}`;
  }

  // For other local files, build the URL with asset URL
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${config.assetUrl}${cleanPath}`;
};

/**
 * Get fetch options with appropriate credentials setting based on CORS
 */
export const getFetchOptions = (options: RequestInit = {}): RequestInit => {
  if (config.corsEnabled) {
    // In production with CORS, include credentials
    return {
      ...options,
      credentials: 'include' as RequestCredentials,
    };
  } else {
    // In development without CORS, omit credentials
    return {
      ...options,
      credentials: 'omit' as RequestCredentials,
    };
  }
};

/**
 * Check if we're in development mode
 */
export const isDevelopment = (): boolean => {
  return config.isDevelopment;
};

/**
 * Check if we're in production mode
 */
export const isProduction = (): boolean => {
  return config.isProduction;
};

export default config;